import dynamic from './dynamic';

export default dynamic;
